ZoneGisementsController.$inject = [
	'$scope',
	'$state',
	'$stateParams',
	'$translate',
	'ModalService',
	'PaginationService',
	'ZoneGisementsService',
	'notification',
	'MassiaApplicationService',
	'$transitions'
];

// Du fait d'une limitation d'angularJS et de blocks.smart.table
// le controller doit être déclaré comme une fonction et non une classe
// on injecte donc directement les dépendances dans la fonction comme le veut angularJS
export default function ZoneGisementsController(
	$scope,
	$state,
	$stateParams,
	$translate,
	ModalService,
	PaginationService,
	ZoneGisementsService,
	notification,
	MassiaApplicationService,
	$transitions
) {
	const vm = this;
	const watchers = [];

	let previousTableState;
	let selectedZoneGisementId = undefined;
	vm.loading = false;
	vm.stateParams = $stateParams;
	vm.zoneGisements = [];

	vm.slideWidth = '500px';
	vm.slideMargin = {
		'margin-right': '0px',
		'transition-duration': '0.5s',
		'transition-animation': 'margin-right',
		height: '100%'
	};

	vm.itemsByPageOptions = [20, 100, 200];
	vm.itemsByPage = vm.itemsByPageOptions[0];

	//vm.selectZoneGisement = selectZoneGisement;
	vm.isZoneGisementSelected = isZoneGisementSelected;
	vm.loadZoneGisements = loadZoneGisements;
	vm.deleteZoneGisement = deleteZoneGisement;
	vm.getApplication = getApplication;

	function init() {
		//écouter l'event lié au changement de route
		//une fois on change l'url, et on arrive sur la page "zone-gisements.list", on désélectionne la ligne sélectionnée (s'il y en a)
		$transitions.onSuccess({}, stateChangeSuccessFunc);
		watchers.push($scope.$on('$destroy', dispose));
	}

	init();

	function stateChangeSuccessFunc(event, toState) {
		if (!$stateParams.id) {
			selectedZoneGisementId = undefined;
		}
	}

	async function getApplication() {
		const app = MassiaApplicationService.getApplication();
		return app;
	}

	function isZoneGisementSelected(zoneGisement) {
		return zoneGisement && zoneGisement.id && selectedZoneGisementId === zoneGisement.id;
	}

	async function loadZoneGisements(tableState) {
		startLoading();

		//quand on rafraîchit la grille, on revient sur "zone-gisements.list", et on ferme la vue détail d'un zoneGisement
		//sinon, on risque d'avoir la vue détail qui est ouverte, mais la ligne n'apparaît plus dans la grille
		let str = 'zone-gisements';
		if (MassiaApplicationService.getApplication() == 'qse') {
			str += '-qse';
		}
		if ($state && $state.current && $state.current.name !== str + '.list') {
			$state.go(str + '.list');
		}

		if (tableState) {
			previousTableState = tableState;
		}

		const filters = PaginationService.getFilters(previousTableState);
		const sorts = PaginationService.getSorts(previousTableState);
		const pagination = PaginationService.getPagination(previousTableState);

		vm.zoneGisements = [];

		try {
			const data = await ZoneGisementsService.getZoneGisements(filters, sorts, pagination);

			vm.zoneGisements = data.items;

			if (previousTableState) {
				PaginationService.setTableState(data.skip, data.take, data.total, previousTableState);
			}
		} catch (ex) {
			notification.error(ex.data);
		} finally {
			stopLoading();
		}
	}

	async function deleteZoneGisement(zoneGisement) {
		if (zoneGisement /*&& zoneGisement.canDelete*/ && zoneGisement.id) {
			const modalInstance = ModalService.confirm({
				modalTitle: $translate.instant('ZONEGISEMENTS.DELETE.TITLE', { code: zoneGisement.libelle }),
				modalMsg: $translate.instant('ZONEGISEMENTS.DELETE.MESSAGE'),
				headerClass: 'modal-danger'
			});

			modalInstance.result.then(async function () {
				startLoading();
				try {
					await ZoneGisementsService.deleteZoneGisementById(zoneGisement.id);
					notification.success($translate.instant('ZONEGISEMENTS.DELETE.SUCCESS'));

					selectedZoneGisementId = undefined;

					loadZoneGisements();
				} catch (ex) {
					notification.error(ex.data);
				} finally {
					stopLoading();
				}
			});
		}
	}

	function startLoading() {
		vm.loading = true;
	}

	function stopLoading() {
		vm.loading = false;
	}

	function dispose() {
		watchers.forEach((x) => x());
	}
}
